export default defineNuxtPlugin((nuxtApp) => {
  const { refreshToken, isAuthenticated, authToken } = useAuth()

  const isTokenExpiring = (token: string) => {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]))
      const exp = payload.exp * 1000
      // Refresh if expiring in less than 5 minutes
      return Date.now() + 300000 > exp
    } catch {
      return true
    }
  }

  if (import.meta.client) {
    // Check every minute
    setInterval(async () => {
      if (isAuthenticated.value && authToken.value) {
        if (isTokenExpiring(authToken.value)) {
           console.debug('Token expiring soon, refreshing...')
           try {
             await refreshToken()
             console.debug('Token refreshed successfully')
           } catch (e) {
             console.error('Auto refresh failed', e)
           }
        }
      }
    }, 60000)
  }
})
